import { type ChangeEvent, useState } from 'react'

import { Box, SearchField } from '@factorialco/deprecated-design-system'
import { PermissionsGetManagePermissionPermissionsQuery } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import { useTextSearch } from 'modules/core/hooks/useTextSearch'
import i18n from 'modules/core/lib/i18n'

import DelegateContextlessPermissionsList from 'modules/permissions/components/DelegateContextlessPermissionsList'
import type PermissionGroup from 'modules/permissions/store/models/PermissionGroup'

type Permission =
  PermissionsGetManagePermissionPermissionsQuery['permissions']['permissions'][number]

interface Props {
  disabled: boolean
  permissionGroup: PermissionGroup
  permissions: Permission[]
}

function DelegateList({ permissionGroup, permissions }: Props) {
  const [search, setSearch] = useState('')
  const searching = search.trim().length > 0
  const onSearch = (event: ChangeEvent<HTMLInputElement>) => {
    setSearch(event.target.value)
  }

  const searchResults = useTextSearch(permissions, search, {
    fields: ['verbLabel', 'categoryLabel'],
    storeFields: ['id'],
    combineWith: 'AND',
    fuzzy: false,
  }).results

  let filteredPermissions = permissions
  if (searching) {
    const matchedIds = new Set(searchResults.map((permission) => permission.id))
    filteredPermissions = filteredPermissions.filter((permission) => matchedIds.has(permission.id))
  }

  return (
    <Box>
      <Box width="full" paddingTop="s8" height="s64">
        <SearchField
          variant="big"
          search={search}
          onSearch={onSearch}
          placeholder={i18n.t('settings.permissions.group.search')}
        />
      </Box>
      {filteredPermissions.length > 0 && (
        <DelegateContextlessPermissionsList
          permissions={filteredPermissions}
          permissionGroup={permissionGroup}
        />
      )}
    </Box>
  )
}

export default observer(DelegateList)
